var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar",attrs:{"role":"navigation","aria-label":"main navigation"}},[_c('div',{staticClass:"container"},[_c('AppHeaderBrand'),_c('div',{staticClass:"navbar-menu",attrs:{"id":"navigation"}},[_c('AppHeaderStart'),_c('AppHeaderEnd')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }